import { render, staticRenderFns } from "./OliveOilThumb.vue?vue&type=template&id=73592872&scoped=true"
import script from "./OliveOilThumb.vue?vue&type=script&lang=js"
export * from "./OliveOilThumb.vue?vue&type=script&lang=js"
import style0 from "./OliveOilThumb.vue?vue&type=style&index=0&id=73592872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73592872",
  null
  
)

export default component.exports